import { InputAdornment, TextField } from "@mui/material";
import { ChangeEvent, FC, ReactNode } from "react";
import { SearchOutlined } from "@mui/icons-material";
import { StyledButton } from "../atoms";
import { Title } from "./Title";

interface TableTitleProps {
  title: string;
  btnText?: string;
  btnCondition?: boolean;
  onClick?: () => void;
  search?: string;
  extraRight?: ReactNode;
  setSearch?: (newSearch: string) => void;
}

const TableTitle: FC<TableTitleProps> = ({
  title,
  setSearch,
  search,
  onClick,
  btnText,
  btnCondition = true,
  extraRight,
}) => {
  const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (setSearch) {
      setSearch(e?.target?.value);
    }
  };

  return (
    <Title
      title={title}
      rightSide={
        <>
          {setSearch && (
            <TextField
              type="text"
              placeholder="Search"
              value={search}
              onChange={handleSearchChange}
              size="small"
              slotProps={{
                input: {
                  endAdornment: (
                    <InputAdornment position="end">
                      <SearchOutlined />
                    </InputAdornment>
                  ),
                },
              }}
            />
          )}
          {btnCondition && (
            <StyledButton
              style={{ marginLeft: 10 }}
              variant="contained"
              onClick={onClick}
            >
              {btnText}
            </StyledButton>
          )}
          {extraRight}
        </>
      }
    />
  );
};

export { TableTitle };
